import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LOGO_URL = "/media/img/capella-logo.png";

const NAV = [
  { label: "Ana Sayfa",      to: "/" },
  { label: "Rehber",         to: "/kapadokya-rehberi" },
  { label: "Günlük",         to: "/kapadokya-gunlugu" },
  { label: "Ansiklopedi",    to: "/kapadokya-ansiklopedisi" },
  { label: "Capella Cave",   to: "/capella-cave" },
  { label: "Kurucu Misafir", to: "/kurucu-misafir-listesi" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const HERO_ROUTES = ["/", "/capella-cave", "/kurucu-misafir-listesi"];
  const isHeroRoute = HERO_ROUTES.includes(location.pathname);
  const isSolid = scrolled || !isHeroRoute;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); setScrolled(window.scrollY > 30); }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isSolid ? "bg-cc-bg/95 backdrop-blur-md border-b border-cc-border/60" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between py-3">
        <Link to="/" data-testid="site-logo" className="flex items-center gap-3 group" aria-label="Capella Cave">
          <img
            src={LOGO_URL}
            alt="Capella Cave"
            className="h-16 md:h-20 w-auto transition-all duration-500"
            style={{
              filter: isSolid
                ? "none"
                : "brightness(0) invert(1) drop-shadow(0 2px 14px rgba(0,0,0,0.6))",
            }}
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-8 xl:gap-10">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.to.replace(/\//g, "") || "home"}`}
              className={({ isActive }) =>
                `text-[11px] tracking-[0.22em] uppercase transition-colors duration-300 ${
                  isActive
                    ? "text-cc-sepia"
                    : isSolid ? "text-cc-text hover:text-cc-sepia" : "text-cc-bg/85 hover:text-cc-bg"
                }`
              }
              end={n.to === "/"}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center">
          <div className="text-[10px] tracking-[0.22em] uppercase" data-testid="lang-switcher">
            <span className={isSolid ? "text-cc-text font-medium" : "text-cc-bg font-medium"}>TR</span>
            <span className={`mx-2 ${isSolid ? "text-cc-faint" : "text-cc-bg/40"}`}>·</span>
            <span className={isSolid ? "text-cc-faint cursor-not-allowed" : "text-cc-bg/40 cursor-not-allowed"} title="Yakında">EN</span>
          </div>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className={`lg:hidden ${isSolid ? "text-cc-text" : "text-cc-bg"}`}
          onClick={() => setOpen((o) => !o)}
          aria-label="Menü"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-cc-bg border-t border-cc-border" data-testid="mobile-menu">
          <nav className="flex flex-col px-6 py-7 gap-5">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} className="text-sm tracking-[0.22em] uppercase text-cc-text hover:text-cc-sepia">{n.label}</Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
